function scrollToTop(element: Element | null) {
  if (element) {
    element.scrollTop = 0;
  }
}

function scrollToBottom(element: Element | null) {
  if (element) {
    element.scrollTop = element.scrollHeight;
  }
}

function isScrolledToBottom(element: Element | null) {
  if (element) {
    return Math.floor(element.scrollHeight - element.scrollTop - element.clientHeight) <= 0;
  }

  return false;
}

export default {
  scrollToTop,
  scrollToBottom,
  isScrolledToBottom,
};
